import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { getPostalAddress, getPublicPostalAddress, POSTAL_ADDRESS_TAGS, PUBLIC_POSTAL_ADDRESS_TAGS } from './endpoints';

const locationApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getPostalAddress: getPostalAddress(builder),
      getPublicPostalAddress: getPublicPostalAddress(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [POSTAL_ADDRESS_TAGS, PUBLIC_POSTAL_ADDRESS_TAGS],
  });

export const { useLazyGetPublicPostalAddressQuery, useLazyGetPostalAddressQuery } = locationApi;
